'use strict';

var ALLOWED_PREFIXES = ['I', 'M', 'P', 'J'];
var FORM_SELECTOR  = '#trackorder-form';
var INPUT_SELECTOR = '#trackorder-form-number';
var ERROR_SELECTOR = '#form-number-error';

/**
 * Normalize input value to uppercase, validate prefix,
 * update UI feedback
 */
function normalizeAndValidateOrderNumberInput($input, $error) {
    if (!$input || !$input.length) return true;

    var rawValue = ($input.val() || '').toString();
    var upperValue = rawValue.toUpperCase().trim();

    if (rawValue !== upperValue) {
        $input.val(upperValue);
    }

    // Empty value: clear error state and let "required" attribute handle blocking
    if (!upperValue) {
        if ($input[0]) $input[0].setCustomValidity('');
        $input.removeClass('is-invalid').removeAttr('aria-invalid');
        if ($error && $error.length) $error.empty().hide();
        return true;
    }

    var isValidPrefix = ALLOWED_PREFIXES.indexOf(upperValue.charAt(0)) !== -1;
    var validationMessage = 'Order number must start with I, J, M or P';

    if ($input[0]) $input[0].setCustomValidity(isValidPrefix ? '' : validationMessage);
    $input.toggleClass('is-invalid', !isValidPrefix).attr('aria-invalid', isValidPrefix ? null : 'true');

    if ($error && $error.length) {
        if (isValidPrefix) {
            $error.empty().hide();
        } else {
            $error.text(validationMessage).show();
        }
    }

    return isValidPrefix;
}

function attachOrderLookupValidation() {
    var $form = $(FORM_SELECTOR);
    var $input = $(INPUT_SELECTOR);
    var $error = $(ERROR_SELECTOR);

    if (!$form.length || !$input.length) {
        return; // form not present, do nothing
    }

    $input.on('input blur', function () {
        normalizeAndValidateOrderNumberInput($input, $error);
    });

    $form.on('submit', function (e) {
        if (!normalizeAndValidateOrderNumberInput($input, $error) || !this.checkValidity()) {
            e.preventDefault();
            e.stopPropagation();
            $input.trigger('focus');
            $form.addClass('was-validated');
        } else {
            $form.removeClass('was-validated');
        }
    });

    normalizeAndValidateOrderNumberInput($input, $error);
}

module.exports = function initializeOrderLookupValidation() {
    attachOrderLookupValidation();
};
